import React from 'react';

import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ITextFieldProps, TextField } from '../../../../ui';
import { useFormContext } from 'react-hook-form';

export const VehicleDescription = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<TextField
			type="text"
			label={t('user_form_vehicle_description_label')}
			invalid={!!errors.description}
			error={errors.description?.message as string}
			{...props}
			{...register('description')}
		/>
	);
};
